"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./stylesheet.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Loader = function Loader(_ref) {
  var text = _ref.text,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rest = _objectWithoutProperties(_ref, ["text", "className"]);

  return _react.default.createElement("figure", _extends({
    className: "p-loader ".concat(className)
  }, rest), _react.default.createElement("svg", {
    viewBox: "0 0 100 100"
  }, _react.default.createElement("path", {
    d: "M50,100C22.4,100,0,77.6,0,50S22.4,0,50,0s50,22.4,50,50S77.6,100,50,100z M50,4C24.6,4,4,24.6,4,50 s20.6,46,46,46s46-20.6,46-46S75.4,4,50,4z"
  }), _react.default.createElement("path", {
    d: "M85,51.5C85,51.5,85,51.5,85,51.5L50,51c-0.6,0-1-0.5-1-1s0.5-1,1-1l35,0.5c0.6,0,1,0.5,1,1 C86,51.1,85.5,51.5,85,51.5z"
  }, _react.default.createElement("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })), _react.default.createElement("path", {
    d: "M49.5,75C49.5,75,49.5,75,49.5,75c-0.6,0-1-0.5-1-1L49,50c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1l-0.5,24 C50.5,74.6,50,75,49.5,75z"
  }, _react.default.createElement("animateTransform", {
    attributeName: "transform",
    dur: "15s",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  }))), text && _react.default.createElement("small", null, text));
};

Loader.propTypes = {
  text: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = Loader;
exports.default = _default;